module.exports = __webpack_public_path__ + "img/educacao.2a9a94df.svg";